import { render } from "./blog-detail.vue?vue&type=template&id=1be16762"
import script from "./blog-detail.vue?vue&type=script&lang=js"
export * from "./blog-detail.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__